// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".story-widget{display:flex;flex-direction:column;align-items:flex-start}.story-widget__logo{max-width:100%;max-height:28px;margin:18px 0 32px}.story-widget__inner{flex-grow:1;display:flex;flex-direction:column;align-items:flex-start}.story-widget__description{font-size:14px;line-height:20px;max-width:292px;margin-bottom:24px}.story-widget__link{margin-top:auto;margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
